import React from "react";
import { Link } from "react-router-dom";

import BoxImage from "../../images/home/main_section_bullet--blue.svg";
export default function OrgaCheckHome() {
	return (
		<div className="banalyst">
			<div className="main-fields">
				<div className="field-hd">
					<h2>Orga Check-Konzept</h2>
				</div>

				<div className="d-flex w-100">
					<div className="picture-cards-lg w-100 home-product-box">
						<Link
							to={"/beratungsfelder/fokusthema/orgacheck"}
							className="picture-cards-lg__card product_check"
						>
							<span className="picture-cards-lg__card-title ">
								<span className="picture-cards-lg__card-title-wrapper">
									<div className="ebook-desc product-home">
										<h3 className="px-2 h-25">Orga Check-Konzept</h3>
										<p className="px-2 h-50">
											Orga Check-Konzept der Feingeist Beratung
										</p>
									</div>
								</span>
							</span>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
